document.querySelectorAll('[data-open-panel]').forEach(button => {

  button.addEventListener('click', () => {

    const panelId = button.dataset.openPanel

    const panel = document.getElementById(panelId)

    if (panel) {
      panel.classList.add('is-active')
    }

  })

})

document.querySelectorAll('[data-back]').forEach(button => {

  button.addEventListener('click', () => {

    button.closest('.mobile-panel')
      .classList.remove('is-active')

  })

})